import type { FluxErrorEntityErrorCodes } from '../../types.js';

export const AutomationV2ExecutionActionUpdateCardNameCodes = {
  AutomationV2ExecutionActionUpdateCardNameFailedToUpdate: {
    code: 'automation-v2-execution-action/update-card-name-failed-to-update',
    explanation: `Não foi possível atualizar o nome do card.

**Causas comuns:**
- Card bloqueado ou arquivado
- Permissões insuficientes
- Nome inválido (vazio ou muito longo)

**Como resolver:**
Verifique se o card está ativo e se o novo nome é válido.`,
    localizations: {},
    message: 'Falha ao atualizar o nome do card.',
    supportingDocs: [
      {
        name: 'Ação de Atualizar Nome do Card',
        path: '/wiki/docs/automations/actions/update-card-name',
      },
    ],
  },
  AutomationV2ExecutionActionUpdateCardNameMissingCardId: {
    code: 'automation-v2-execution-action/update-card-name-missing-card-id',
    explanation: `ID do card não fornecido para atualização do nome.

**Causas comuns:**
- Variável \`context.card.id\` não resolvida
- Mapeamento manual incorreto

**Como resolver:**
Forneça um ID de card válido.`,
    localizations: {},
    message: 'ID do card é obrigatório para atualização do nome.',
    supportingDocs: [
      {
        name: 'Ação de Atualizar Nome do Card',
        path: '/wiki/docs/automations/actions/update-card-name',
      },
    ],
  },
} as const satisfies FluxErrorEntityErrorCodes<'automation-v2-execution-action'>;
